<template>
  <div class="full-screen-text" v-if="isFrameType" @click="toggle" :style="getTechnologyFrameTextColor">
    {{ getTextTitle }}
  </div>
  <Tooltip v-else :title="getTitle" placement="bottom" :mouseEnterDelay="0.5">
    <span @click="toggle">
      <FullscreenOutlined v-if="!isFullscreen" />
      <FullscreenExitOutlined v-else />
    </span>
  </Tooltip>
</template>
<script lang="ts">
  import { defineComponent, computed, unref } from 'vue';
  import { Tooltip } from 'ant-design-vue';
  import { useI18n } from 'vue-i18n';
  import { useFullscreen } from '@vueuse/core';
  import { useAppFrame } from '@/hooks/useAppFrame';
  import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons-vue';
  export default defineComponent({
    name: 'FullScreen',
    components: { FullscreenExitOutlined, FullscreenOutlined, Tooltip },

    setup() {
      const { t } = useI18n();
      const { toggle, isFullscreen } = useFullscreen();
      const { isFrameType,getTechnologyFrameTextColor } = useAppFrame();


      const getTitle = computed(() => {
        return unref(isFullscreen)
          ? t('layout.header.tooltipExitFull')
          : t('layout.header.tooltipEntryFull');
      });

      const getTextTitle = computed(() => {
        return unref(isFullscreen)
          ? t('layout.header.exitFullScreen')
          : t('layout.header.fullScreen');
      });

      return {
        getTitle,
        isFullscreen,
        toggle,
        isFrameType,
        getTechnologyFrameTextColor,
        getTextTitle,
      };
    },
  });
</script>
<style lang="less" scoped>
.full-screen-text {
  font-size: 14px;
  // color: #FFF;
  cursor: pointer;
}
</style>